/// <reference path="adpIntegration.module.ts" />
/// <reference path="../../components/common/businessinfo.service.ts" />
/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/commonClasses/commonControllerBase.ts" />

module Meevo.Plugins.AdpIntegration {
    export abstract class AdpIntegrationController extends Meevo.Components.CommonClasses.CommonControllerBase {
        // statically inject constructor resources
        static $inject = [
            "meevo.AppSettings",
            "meevo.components.common.adpIntegrationService",
            "meevo.components.modal.ModalService",
            "meevo.components.common.IdentityService",
            "meevo.components.logging.LoggingService",
            "meevo.components.common.SecurityService",
            "meevo.components.tracking.TrackingService",
            "$rootScope",
            "$scope",
            "$state",
            "$translate",
            "meevo.ContextParams",
            'meevo.components.short-cuts.ShortCutsService',
            "meevo.components.busy.BusyService"
        ];

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.Common.AdpIntegrationService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected loggingService: Meevo.Components.Logging.ILoggingService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected $rootScope: angular.IRootScopeService,
            protected $scope: angular.IScope,
            protected $state: any,
            protected contextParams: Meevo.IContextParams,
            protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
            protected busyService: Meevo.Components.Busy.IBusyService       ) {

            super(appSettings, dataService, modalService, identityService, loggingService, $scope, contextParams, $state, $rootScope, shortCutsService);

            this.createContext();
        }

        createContext(): void {
            super.createContext();
        }

    }
}

